module.exports = __webpack_public_path__ + "img/envelope-open.876c2019.svg";